import { useQuery } from "@tanstack/react-query";
import { messagesService } from "../service/message.service";

export const useMessages = () => {
  return useQuery({
    queryKey: ['get messages'], 
    queryFn: () => messagesService.getAll(),
    select: (data) => data, 
    staleTime: 1000 * 60 * 5, 
  });
};